<template>
  <div
    class="gridview-contaiter"
    :style="{ backgroundImage: `url(${url + bgImageUrl})` }"
  >
    <van-nav-bar title="比赛活动">
      <template #left>
        <img
          class="leftImg"
          @click="$router.push('/home')"
          src="@/assets/jiantou@2x.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <!-- 中间内容区域 -->
    <div class="content-box">
      <div class="time-box">
        <van-count-down
          :time="answerTime * 1000"
          @finish="finish"
          ref="countDown"
        >
          <template #default="timeData" format="HH:mm:ss:SS">
            <img
              class="downImg"
              :src="
                libId == 2
                  ? require('@/assets/shalou1@2x.png')
                  : require('@/assets/shalou@2x.png')
              "
              alt=""
            />
            <div class="timebox">
              <span class="block" :style="libId == 2 ? 'color:#f1a525;' : ''"
                >{{ timeData.seconds }}S</span
              >
            </div>
          </template>
        </van-count-down>
      </div>
      <div class="title-nums">
        <h4 :style="libId == 2 ? 'color:#f1a525;' : ''">
          第{{ this.questionNumber + 1 }}题，共{{ this.questionCount }}题
        </h4>
      </div>
      <div class="title-clue">
        <p :style="libId == 2 ? 'color:#f1a525;' : ''">
          {{ this.questionNumber + 1 }}、{{ this.title }}
        </p>
      </div>
      <ul class="grid-boxs">
        <li
          class="grids"
          v-for="(item, index) in gongeArr"
          :key="index"
          @click="removeItem(item, index)"
        >
          <span class="text-name">{{ item.gongetext }}</span>
        </li>
      </ul>
      <!-- 九宫格、一行三格、无边框、正方形 -->
      <van-grid column-num="3" :border="true" square>
        <!-- for循环 -->
        <van-grid-item
          use-slot
          v-for="(item, index) in gonggeOption"
          :key="index"
          @click="onclick(item, index)"
        >
          <span class="girds-text">{{ item }}</span>
        </van-grid-item>
      </van-grid>
      <!-- 弹出层 -->
      <van-popup v-model="show" closeable close-icon="close" @close="onClosed">
        <div
          :class="
            isPrize == 1
              ? propsList.score >= lotteryConditions
                ? 'box'
                : 'boxss'
              : 'boxs'
          "
        >
          <div class="fireworks"></div>
          <div class="title-top">
            <span class="marks">{{ this.propsList.score }}</span
            ><span class="divide">分</span>
          </div>
          <!-- 弹出层根据分数显示文字 -->
          <div class="text-p">
            <img
              class="textgo"
              v-if="this.propsList.score <= 50"
              src="@/assets/textgo@2x.png"
              alt=""
            />
            <img
              class="textnice"
              v-else
              src="@/assets/textnice@2x.png"
              alt=""
            />
          </div>
          <div class="threediv">
            <div class="boxes">
              <span class="topics">答对</span>
              <p class="answer">{{ this.propsList.correctNums }}道</p>
            </div>
            <div class="line"></div>
            <div class="boxes">
              <span class="topics">答错</span>
              <p class="answer">{{ this.propsList.wrongNums }}道</p>
            </div>
            <div class="line"></div>
            <div class="boxes">
              <span class="topics">用时</span>
              <p class="answer">{{ this.propsList.timeUse }}s</p>
            </div>
          </div>
          <div class="btn-two">
            <van-button
              type="danger"
              size="small"
              plain
              round
              @click="$router.push('/my')"
              style="width: 30%; border: 1px solid #b7b7b7"
              >再来一次</van-button
            >
            <van-button
              type="danger"
              size="small"
              plain
              round
              @click="torank(0)"
              style="
                width: 30%;
                border: 1px solid #d81a1e;
                margin-left: 20px;
                background: #d81a1e;
                color: #ffffff;
              "
              >排行榜</van-button
            >
            <van-button
              color="#D81A1E"
              round
              size="small"
              style="width: 70%; margin-top: 20px"
              @click="torank(1)"
              >答案</van-button
            >
            <div v-if="isPrize == 1">
              <div
                v-if="propsList.score >= lotteryConditions"
                class="lottery"
                @click="$router.push('/activeWheel')"
              >
                <img
                  class="lottery-img"
                  src="../../assets/zpqietu/djcj@2x.png"
                  alt=""
                />
                <img
                  class="lottery-box"
                  src="../../assets/zpqietu/cjlb@2x.png"
                  alt=""
                />
              </div>
              <div v-else class="noprize">
                您未答对{{ lotteryConditions / score }}题，未获得本次抽奖机会
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { answering } from "@/api/answer";
import { getActionConfig } from "@/api/rank";
import JSONBig from "json-bigint";
import qs from "qs";
import msgFun from "js-md5";
import shaFun from "sha1";
import { Toast } from "vant";
import Common from "@/components/comm";
// 九宫格
export default {
  name: "gridview",
  components: {},
  props: {},
  data() {
    return {
      url: Common.getUrl(),
      show: false,
      title: "",
      answerTime: "", //答题时间
      dataInfo: {}, //总数据
      gonggeOption: [], //九宫格数据
      answerType: "", //题型类型
      questionNumber: 0, //第几题
      questionCount: 0, //答题题数
      propsList: [], //弹出框列表
      gonggeCount: "", //空白格显示数
      gongeArr: [], //空白格数组
      gongKey: 0, //空白格索引
      first: 1,
      isfist: true, //控制按钮触发一次
      isPrize: "",
      encrypt: "CXCW",
      encrypts: "2022",
      lotteryConditions: "",
      score: "",
      bgImageUrl: "",
      libId: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.bgImageUrl = window.localStorage.getItem("imgUrl");
    this.getActionConfigs();
    this.dataInfo = this.$route.params.dataInfo;
    if (this.dataInfo) {
      this.title = this.dataInfo.question.title;
      this.gonggeOption = this.dataInfo.question.gonggeOption;
      this.gonggeCount = this.dataInfo.question.gonggeCount;
      this.answerType = this.dataInfo.question.answerType;
      this.questionNumber = this.dataInfo.questionNumber;
      this.questionCount = this.dataInfo.questionCount;
      for (let i = 0; i < this.gonggeCount; i++) {
        let gonge = { gongetext: "", gongeIndex: i };
        this.gongeArr.push(gonge);
      }
    } else {
      this.$router.push("/home");
    }
    this.libId = window.localStorage.getItem("libId");
  },
  mounted() {
    var newDate = new Date().getTime();
    this.userTimeEnd = newDate; //当前时间
  },
  methods: {
    // 跳转排行页
    torank(i) {
      this.$router.push({
        name: "ranking",
        query: {
          active: i,
        },
      });
    },

    // 拿到答题时间
    async getActionConfigs() {
      const { data: res } = await getActionConfig();
      this.answerTime = res.data.answerTime;
      this.isPrize = res.data.isPrize;
      this.lotteryConditions = res.data.lotteryConditions;
      this.score = res.data.score;
    },
    onClosed() {
      this.$router.push("/home");
    },
    async btnInfo() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: "加载中...",
        forbidClick: true, //禁用背景点击
        overlay: true, //是否显示背景遮罩层
      });
      let arr = this.gongeArr.map((item) => item.gongetext);
      let timestamp = Date.parse(new Date());
      var newDate = new Date().getTime();
      this.useTime = newDate - this.userTimeEnd;
      let queryInfo = {
        questionNumber: this.dataInfo.questionNumber,
        answerIds: arr.join(""),
        questionId: this.dataInfo.question.id, //问题id
        answerContents: arr.join(""),
        timeUse: this.useTime,
        answerStatisticsId: this.dataInfo.answerStatisticsId,
        timestamp: timestamp,
      };
      let new_encrypt = this.encrypt;
      let new_key = this.encrypts;
      var token = msgFun(arr.join("") + this.useTime + timestamp + new_encrypt);
      let tokenStr = msgFun(shaFun(token + new_key));
      this.$Cookies.set("token", tokenStr);
      const { data: res } = await answering(qs.stringify(queryInfo));
      this.propsList = res.data;
      if (res.data.isFinish) {
        Toast.clear();
        this.show = true;
        return;
      } else {
        Toast.clear();
        let type = res.data.question.answerType; //提交按钮获取到的题目类型
        let ques = this.dataInfo.question.answerType; //传过来题目类型
        if (res.data.question.answerType == 1) {
          this.$router.push({
            name: "choicePage",
            params: {
              dataInfo: res.data,
            },
          });
        } else if (res.data.question.answerType == 2) {
          this.$router.push({
            name: "mulChoice",
            params: {
              dataInfo: res.data,
            },
          });
        } else if (
          res.data.question.answerType == 3 ||
          res.data.question.answerType == 4
        ) {
          this.$router.push({
            name: "gamePage",
            params: {
              dataInfo: res.data,
            },
          });
        } else if (res.data.question.answerType == 5) {
          this.$router.push({
            name: "crossPicture",
            params: {
              dataInfo: res.data,
            },
          });
          // 宫格
        } else if (res.data.question.answerType == 6) {
          // 判断跳转同一题型，解决同页面渲染重复问题
          // 接口获取的题型 是否等于 点击按钮获取到的题型（下一题型）
          if (type == ques) {
            // 重置数据
            this.dataInfo = res.data;
            if (this.dataInfo) {
              this.title = this.dataInfo.question.title;
              this.gonggeOption = this.dataInfo.question.gonggeOption; //九宫格列表
              this.gonggeCount = this.dataInfo.question.gonggeCount;
              this.answerType = this.dataInfo.question.answerType;
              this.questionNumber = this.dataInfo.questionNumber;
              this.questionCount = this.dataInfo.questionCount;
              this.gongKey = 0;
              this.gongeArr = [];
              for (let i = 0; i < this.gonggeCount; i++) {
                let gonge = { gongetext: "", gongeIndex: i };
                this.gongeArr.push(gonge);
              }
              var newDate = new Date().getTime();
              this.userTimeEnd = newDate; //当前时间
              this.$refs.countDown.reset(); //重设倒计时
            } else {
              this.$router.push("/home");
            }
          } else {
            this.$router.push({
              name: "gridview",
              params: {
                dataInfo: res.data,
              },
            });
          }
        } else {
          return;
        }
      }
    },
    // 九宫格点击事件
    onclick(item, index) {
      this.gongeArr[this.gongKey].gongetext = item;
      this.gongKey = this.gongKey + 1;
      if (this.gongKey >= this.gonggeCount) {
        var newDate = new Date().getTime();
        this.$refs.countDown.pause(); //暂停倒计时
        this.useTime = newDate - this.userTimeEnd; //当前时间-答题时间=用时时间
        this.btnInfo();
      }
    },
    // 九宫格五个删除点击事件
    removeItem(item, index) {
      this.gongKey = 0;
      this.gongeArr.forEach((val) => {
        val.gongetext = "";
      });
    },
    // 倒计时结束触发
    finish() {
      if (this.first == 1) {
        this.first = 2;
        return;
      }
      this.btnInfo();
    },
  },
};
</script>
<style scoped lang="less">
.gridview-contaiter {
  width: 100%;
  height: 100%;
  // background: url("../../assets/picture/bj@2x.png") no-repeat center center;
  // background-size: 100% 100%;
  background-size: 100% 100%;
  overflow: auto;
}
::v-deep .van-nav-bar .van-icon {
  color: #000;
}
.leftImg {
  width: 27px;
  height: 44px;
}
.content-box {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}
.time-box {
  float: left;
  width: 200px;
}
.timebox {
  display: inline-block;
  margin-left: 30px;
}
.downbox {
  margin-left: 30px;
}
.downImg {
  width: 36px;
  height: 57px;
  margin-left: 30px;
  -webkit-animation: round_animate 5s linear infinite;
  animation: round_animate 5s linear infinite;
}
@keyframes round_animate {
  to {
    transform: rotate(1turn);
  }
}
.block {
  font-size: 46px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #b75e24;
}
.title-nums {
  margin-top: 30px;
  text-align: center;
  width: 100%;
}
h4 {
  font-size: 40px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #000000;
}
.title-clue {
  margin-top: 50px;
  text-align: center;
  width: 100%;
  font-size: 32px;
  font-family: MicrosoftYaHei;
  color: #000000;
  font-weight: bold;
}
.grid-boxs {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.grids {
  position: relative;
  width: 100px;
  height: 100px;
  background: #ffffff;
  border-radius: 16px;
  border: 4px solid #ccc;
  margin: 20px 10px;
}

.text-name {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 34px;
  font-weight: normal;
}
::v-deep .van-grid {
  width: 360px;
  margin: 30px auto;
  text-align: center;
}
::v-deep .van-grid-item {
  font-size: 34px;
}
.box {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 587px;
  height: 1018px;
  border-radius: 16px;
  background: url("../../assets/zpqietu/tck@2x.png") no-repeat;
  background-size: 100% 100%;
}
.boxs {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 587px;
  height: 656px;
  border-radius: 16px;
  background: url("../../assets/zpqietu/tc@2x.png") no-repeat;
  background-size: 100% 100%;
}
.boxss {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 587px;
  height: 784px;
  border-radius: 16px;
  background: url("../../assets/zpqietu/dt2.png") no-repeat;
  background-size: 100% 100%;
}
.fireworks {
  height: 200px;
}
.fireworkImg {
  width: 608px;
  margin-left: -30px;
}
.title-top {
  position: absolute;
  top: 80px;
  left: 52%;
  transform: translateX(-50%);
  height: 80px;
  margin: 0 auto;
  text-align: center;
}
::v-deep .van-popup__close-icon--top-right {
  position: absolute;
  right: 45%;
  top: 700px;
  margin: 0 auto;
  font-size: 56px;
}
::v-deep .van-popup {
  width: 100%;
  height: 1108px;
  background-color: transparent;
}
::v-deep .van-popup--center {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.marks {
  font-family: "Lucida Console", "Courier New", monospace;
  font-weight: bold;
  color: rgb(216, 26, 30);
  text-shadow: 2px 1px #8a2426;
  font-size: 72px;
}
.divide {
  font-family: "Lucida Console", "Courier New", monospace;
  font-weight: bold;
  color: rgb(216, 26, 30);
  font-size: 30px;
}
.text-p {
  position: absolute;
  top: 225px;
  left: 50%;
  transform: translate(-50%);
}
.textnice {
  width: 325px;
  height: 35px;
}
.textgo {
  width: 400px;
  height: 35px;
}
.threediv {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100%;
  margin: 0 auto;
  margin-top: 85px;
}
.boxes {
  position: relative;
  width: 120px;
  margin: 0 30px;
  text-align: center;
}
.answer {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #363636;
  width: 100px;
}
.topics {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #757575;
}
.line {
  width: 1px;
  height: 61px;
  background: #dbdbdb;
}
.btn-two {
  text-align: center;
  margin-top: 60px;
}
::v-deep .van-button--primary {
  border: 0.02667rem solid #b7b7b7;
}
::v-deep .van-button--plain.van-button--primary {
  color: #d81a1e;
}

.btn-one {
  position: absolute;
  bottom: 246px;
  left: 55%;
  transform: translateX(-50%);
  height: 120px;
  width: 80%;
  margin: 0 auto;
}
::v-deep .van-button__text {
  font-size: 28px;
}
::v-deep .van-button {
  border: 1px solid #b7b7b7;
}
.lottery {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 40px;
}
.lottery-img {
  width: 108px;
  height: 173px;
}
.lottery-box {
  width: 368px;
  height: 359px;
  margin-left: -50px;
}
::v-deep .van-popup__close-icon--top-right {
  position: absolute;
  right: 3%;
  top: 10px;
}
.noprize {
  position: absolute;
  bottom: 50px;
  width: 100%;
  font-size: 30px;
  font-weight: 400;
  color: #d81a1e;
  margin: 0 auto;
}
</style>
